import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

export interface ResultsPageLoaderProps {
  isPrevious: boolean;
  limit: number;
  setOffset: (offset: number) => void;
  offset: number;
}

/**
 * A pager component that renders a "show next" or "show previous" link that uses a fixed limit and shifts
 * the pagination offset in the appropriate direction.
 */
class ResultsPageLoader extends React.Component<ResultsPageLoaderProps> {
  private handlePageResults = (e: ElementMouseEvent): void => {
    e.preventDefault();
    const {isPrevious, limit, setOffset, offset} = this.props;
    const newOffset = isPrevious ? offset - limit : offset + limit;
    setOffset(newOffset);
  };

  override render(): JSX.Element {
    return (
      <div className="resultsPageLoader">
        <a
          {...getTestProps({
            component: 'ResultsPageLoader',
            element: this.props.isPrevious ? 'showPrevious' : 'showNext',
          })}
          className="legacy-font-proxima-14"
          onClick={this.handlePageResults}
        >
          <BenchlingIcon
            className="resultsLoader-icon"
            icon={this.props.isPrevious ? 'chevron-up' : 'chevron-down'}
          />
          <span>{this.props.isPrevious ? 'Show Previous' : 'Show Next'}</span>
        </a>
      </div>
    );
  }
}

export default ResultsPageLoader;
